import {
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  IconButton as MuiIconButton,
  type IconButtonProps as MuiIconButtonProps,
} from '@mui/material'
import { type SystemCssProperties } from '@dhl-ui/theme'
import { type BaseProps } from '../../types'

type BaseColor = 'primary' | 'error' | 'info' | 'success' | 'dark' | 'inherit' | 'alternative'

export type IconButtonProps = BaseProps<
  HTMLButtonElement,
  never,
  Pick<SystemCssProperties, 'position' | 'top' | 'left' | 'right' | 'bottom'>
> &
  Omit<MuiIconButtonProps, 'sx' | 'className' | 'color'> & {
    variant?: 'outlined' | 'ghost' | 'contained'
    square?: boolean
    color?: BaseColor
    title?: string
    'aria-label': string
  }

/**
 * IconButton
 *
 * Demos:
 * - [IconButton](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/primitives-iconbutton--docs)
 *
 */
export const IconButton = ({ children, sx, square, ...props }: IconButtonProps) => (
  <MuiIconButton disableRipple {...props} sx={sx} className={`DhlIconButton${square ? ' DhlIconButton--square' : ''}`}>
    {children}
  </MuiIconButton>
)
